import { IWebinar } from '@src/webinar/types';
import { IPeerInfo, TPeerActionTypes } from './users.types';
import { MEETING_TYPE } from '@src/constants';

export type TMeetingType = (typeof MEETING_TYPE)[keyof typeof MEETING_TYPE];

export type TDrawerOptions =
  | 'chat'
  | 'polls'
  | 'participants-list'
  | 'notes'
  | 'question-and-answer'
  | 'virtual-background'
  | 'settings'
  | 'calculator';

export type TPeerActionCallbackProps = {
  id: string;
  msg?: string;
  emit?: boolean;
  info?: boolean;
  from_peer_name: string;
  action: TPeerAction;
  broadcast?: boolean;
  record_id?: string; // Added record_id to the action callback props
  extraFields?: {
    deleteMessages?: boolean;
  };
};

export interface IHandleUpdatePeerInfo {
  peer_name?: string;
  peer_id: string;
  type: TPeerActionTypes;
  status: boolean;
  emit?: boolean;
  presenter?: boolean;
  extraData?: Partial<IPeerInfo> & { initiator_peer_id?: string };
  extraFields?: {
    lang?: string;
  };
}

export type TPeerAction =
  | 'mute'
  | 'eject'
  | 'ban'
  | 'stop'
  | 'start'
  | 'requestToUnmute'
  | 'requestOpenCamera'
  | 'updateUserType'
  | 'stopScreenSharingAll';

export type TEmojiId =
  | 'heart'
  | 'thumbsUp'
  | 'clap'
  | 'party'
  | 'monocle'
  | 'surprised'
  | 'tearsOfJoy'
  | 'cryingFace'
  | 'thumbsDown';

export interface IScheduledMeeting extends Omit<IWebinar, 'startTime' | 'endTime'> {
  id: string;
  roomTitle: string;
  type: TMeetingType;
  startTime: Date;
  endTime: Date;
  status: string; //TODO: change to strict values from BE 'SCHEDULED' | 'ACTIVE' | etc.
}

export enum EMeetingType {
  MEETING = 'meeting',
  WEBINAR = 'webinar',
}
